<template>
  <div class="main">
    <div
      class="col-12 d-md-flex justify-content-between justify-content-center"
    >
      <div class="form-row form_padrao">
        <div class="form-group flutuante col-md-12 position-relative">
          <input
            type="text"
            name="pesquisar"
            id="pesquisar"
            v-model="filters['global']"
            required
          />
          <label for="pesquisar">Pesquisar...</label>
        </div>
      </div>
      <button class="btn btn-verde mb-3" @click="exportCSV($event)">
        Exportar fatura
      </button>
    </div>
    <div class="col-12 mb-4">
      <DataTable
        dataKey="id"
        :filters="filters"
        ref="dt"
        :paginator="true"
        :rows="10"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        class="p-datatable-responsive-demo"
        :rowsPerPageOptions="[10, 20, 50]"
        currentPageReportTemplate="Exibindo {first} até {last} de {totalRecords}"
        selectionMode="single"
        :value="faturas"
        data-key="id"
      >
        <template #empty> Você ainda não adquiriu nenhum curso. </template>
        <template #loading> Carregando... </template>
        <Column field="nomedocurso" header="Nome do Curso" sortable></Column>
        <Column field="datacompra" header="Data da compra" sortable>
          <template #body="slotProps">
            {{ slotProps.data.datacompra | formatDate }}
          </template>
        </Column>
        <Column field="quantidade" header="Quantidade" sortable></Column>
        <Column field="formapagto" header="Forma de pagamento" sortable>
          <template #body="slotProps">
            <span class="badge badge-primary">
              {{ slotProps.data.formapagto }}</span
            >
          </template>
        </Column>
        <Column field="vlrtotal" header="Valor total" sortable>
          <template #body="slotProps">
            {{
              (slotProps.data.vlrunitario * slotProps.data.quantidade)
                | currency
            }}
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>

<script>
// import { formata } from "../../helpers";
import DataTable from "primevue/datatable";
import Column from "primevue/column";

export default {
  name: "Meuscursos",
  components: { DataTable, Column },
  data() {
    return {
      filters: {},
      faturas: [],
    };
  },
  filters: {
    currency(valor) {
      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      return formatter.format(valor);
    },
    formatDate(valor) {
      let data = new Date(valor);
      var formatter = new Intl.DateTimeFormat("pt-BR");
      return formatter.format(data);
    },
  },
  methods: {
    exportCSV() {
      this.$refs.dt.exportCSV();
    },
    getFaturas() {
      this.$http
        .post("/api/Ead/RelatorioComprasEAD", {
          datainicial: "2020-09-11T20:24:52.976Z",
          datafinal: new Date().toJSON(),
        })
        .then((response) => {
          this.faturas = response.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  async created() {
    this.getFaturas();
  },
};
</script>
<style lang="scss">
.p-datatable-responsive-demo .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

@media screen and (max-width: 40em) {
  /deep/ .p-datatable {
    &.p-datatable-responsive-demo {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr > td {
        text-align: left;
        display: block;
        width: 100%;
        float: left;
        clear: left;
        border: 0 none;

        .p-column-title {
          padding: 0.4rem;
          min-width: 30%;
          display: inline-block;
          margin: -0.4em 1em -0.4em -0.4rem;
          font-weight: bold;
        }

        &:last-child {
          border-bottom: 1px solid var(--surface-d);
        }
      }
    }
  }
}
</style>
